import ko from 'knockout';
import buildKeyHandler from "./buildKeyHandler";

ko.bindingHandlers['enterKey'] = buildKeyHandler(13);
